module.exports = __webpack_public_path__ + "img/muzzle-flash.8561d74b.png";